import { useMutation, useQueryClient } from "@tanstack/react-query";

import { updateReportTemplate } from "@services/reportEngine";
import { ReportTemplatePayload } from "./useCreateReportTemplate";

export const useUpdateReportTemplate = () => {
  const queryClient = useQueryClient();

  return useMutation(
    ({ id, ...payload }: ReportTemplatePayload & { id: string }) =>
      updateReportTemplate(id, payload),
    {
      onSuccess: (_data, { id }) => {
        queryClient.invalidateQueries(["reportTemplates"]);
        // The detail cache too — the builder loads a template from it, so a
        // stale entry silently hands the next edit the pre-edit definition.
        queryClient.invalidateQueries(["reportTemplate", id]);
      },
    },
  );
};
